import React from 'react'
import { TabPanels, TabPanel } from '@hub/tabs'
import type {
  OpenHamburgerMenuAtPathType,
  LinkItem,
  HeaderVariants,
} from '../types'
import { Centre as CentreType } from '../../../../types/centre'
import { NavLinks } from './nav-links'
import { FindACentreNavPanel } from './find-a-centre-panel'

interface TabsProps {
  variant: HeaderVariants
  centres: CentreType[]
  centre?: CentreType
  primaryLinks?: LinkItem[]
  tertiaryLinks?: LinkItem[]
  openHamburgerMenuAtPath: OpenHamburgerMenuAtPathType
}

export const UniversalHeaderTabs: React.FC<TabsProps> = ({
  variant,
  centres,
  centre,
  primaryLinks,
  tertiaryLinks,
  openHamburgerMenuAtPath,
}) => (
  <TabPanels
    sx={{ bg: 'smoke', borderBottom: '1px', borderBottomColor: 'ghost' }}
  >
    {variant !== 'centre' && variant !== 'gift-cards' && (
      <TabPanel tabIndex={-1} sx={{ padding: 0, height: 'size-8' }}>
        <NavLinks
          primaryLinks={primaryLinks}
          tertiaryLinks={tertiaryLinks}
          openHamburgerMenuAtPath={openHamburgerMenuAtPath}
          tabKey="shop"
          label="Shop online"
        />
      </TabPanel>
    )}

    {variant === 'gift-cards' ? (
      <TabPanel tabIndex={-1} sx={{ padding: 0, height: 'size-8' }}>
        <NavLinks
          primaryLinks={primaryLinks}
          openHamburgerMenuAtPath={openHamburgerMenuAtPath}
          tabKey="gift-cards"
        />
      </TabPanel>
    ) : (
      <TabPanel tabIndex={-1} sx={{ padding: 0, height: 'size-8' }}>
        {centre ? (
          <NavLinks
            primaryLinks={primaryLinks}
            tertiaryLinks={tertiaryLinks}
            openHamburgerMenuAtPath={openHamburgerMenuAtPath}
            tabKey="centre"
            label={centre.title}
          />
        ) : (
          <FindACentreNavPanel centres={centres} />
        )}
      </TabPanel>
    )}
  </TabPanels>
)
